import {
  Box, Card, CardContent, Typography, Stack, Chip, Button, CircularProgress, IconButton,
} from '@mui/material';
import { CheckCircle, Notifications as NotifIcon } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import api from '../../api/axios';

const typeColors = { new_client: 'success', plan_change: 'info', payment: 'success', alert: 'error', system: 'default' };

export default function NotificationsPage() {
  const [notifs, setNotifs] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get('/superadmin/notifications')
      .then(r => { setNotifs(r.data.data.notifications || []); setUnread(r.data.data.unread || 0); })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const markAllRead = async () => {
    await api.patch('/superadmin/notifications/read-all');
    load();
  };

  const markRead = async (id) => {
    await api.patch(`/superadmin/notifications/${id}/read`);
    setNotifs(ns => ns.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    setUnread(u => Math.max(0, u - 1));
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" fontWeight={700}>Notification Center</Typography>
          <Typography variant="body2" color="text.secondary">{unread} unread notifications</Typography>
        </Box>
        {unread > 0 && (
          <Button startIcon={<CheckCircle />} onClick={markAllRead} variant="outlined" size="small">Mark All Read</Button>
        )}
      </Box>

      {notifs.length === 0 && (
        <Card><CardContent sx={{ textAlign: 'center', py: 6 }}>
          <NotifIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
          <Typography color="text.secondary">No notifications</Typography>
        </CardContent></Card>
      )}

      <Stack spacing={1}>
        {notifs.map(n => (
          <Card key={n.id} sx={{ borderLeft: '4px solid', borderLeftColor: n.is_read ? 'divider' : 'primary.main', opacity: n.is_read ? 0.8 : 1 }}>
            <CardContent sx={{ py: '12px !important', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3 }}>
                  <Chip label={n.type.replace(/_/g,' ')} size="small" color={typeColors[n.type] || 'default'} />
                  <Typography variant="body2" fontWeight={n.is_read ? 400 : 700}>{n.title}</Typography>
                  {!n.is_read && <Chip label="New" size="small" color="primary" sx={{ height: 16, fontSize: 10 }} />}
                </Box>
                <Typography variant="body2" color="text.secondary">{n.message}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2, flexShrink: 0 }}>
                <Typography variant="caption" color="text.secondary">
                  {new Date(n.created_at).toLocaleString('en-PK', { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
                </Typography>
                {!n.is_read && (
                  <IconButton size="small" onClick={() => markRead(n.id)} title="Mark as read">
                    <CheckCircle fontSize="small" color="primary" />
                  </IconButton>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
